var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-report"},[_c('iframe',{attrs:{"id":"iframeName","src":_vm.visualSrc,"frameborder":"0","width":"100%","height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }